export enum AsyncTaskStatus {
  Pending = 'Pending',
  Failed = 'Failed',
  Finished = 'Finished',
}
